export default "/icons/figma.svg";